import React, { Fragment } from "react";

const SalaryItem = ({
  setFilters,
  filters,
  setIsChecked,
  isChecked,
  item,
  index,
  formatter,
}) => {
  return (
    <Fragment>
      <div className="flex-only">
        {filters.salary === 0 && (
          <div>
            <input
              type="checkbox"
              name="salary"
              className="job-type"
              value={item.salary}
              onChange={(e) => {
                if (!isChecked.salary) {
                  setFilters({ ...filters, salary: e.target.value });
                  setIsChecked({ ...isChecked, salary: true });
                } else {
                  setFilters({ ...filters, salary: 0 });
                  setIsChecked({ ...isChecked, salary: false });
                }
              }}
            />
            <span className="job-type mt" key={index}>
              {formatter.format(item.salary)}
            </span>
            <br />
          </div>
        )}
        {item.salary == filters.salary && (
          <div>
            <input
              type="checkbox"
              name="salary"
              className="job-type"
              checked
              value={item.salary}
              onChange={(e) => {
                if (!isChecked.salary) {
                  setFilters({ ...filters, salary: e.target.value });
                  setIsChecked({ ...isChecked, salary: true });
                } else {
                  setFilters({ ...filters, salary: 0 });
                  setIsChecked({ ...isChecked, salary: false });
                }
              }}
            />
            <span className="job-type mt" key={index}>
              {formatter.format(item.salary)}
            </span>
            <br />
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default SalaryItem;
